<template>
  <div>
    <div class="flex items-center justify-center border-b pt-0 pb-3">
      <h3 id="collection.title" class="mb-0 text-center w-full">
        {{ translate("Loyalty Points Collection") }}
      </h3>
    </div>

    <div class="px-3 mt-4">
      <form id="collection.form" role="form">
        <div class="flex flex-wrap -mx-2">
          <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="font-bold">
              {{ translate("Customer Mobile Number") }}
              <span class="ml-2 text-red-600">*</span>
            </label>
            <BaseField id="collection.form.mobile" class="font-bold" name="mobile"
              :placeholder="translate('Customer Mobile Number')" v-model="form.mobile" :required="true"
              :error="!schemaValid.mobile" @valid="schemaValid.mobile = $event"
              :error-message="translate('Mobile number is required')" />
          </div>

          <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="font-bold">
              {{ translate("Points") }}
              <span class="ml-2 text-red-600">*</span>
            </label>
            <BaseField id="collection.form.points" class="font-bold" name="points" input-type="number"
              :placeholder="translate('Points')" v-model="form.points" :required="true" :error="!schemaValid.points"
              @valid="schemaValid.points = $event" :error-message="translate('Points are required')" />
          </div>
        </div>

        <section class="flex flex-row justify-end">
          <V2BaseButton id="collection.form.addpoints" variant="primary" :loading="loading"
            :disabled="!schemaValid.mobile || !schemaValid.points || loading" @click.prevent="addPoints">
            {{ translate("ADD POINTS") }}
          </V2BaseButton>
        </section>
      </form>
    </div>
  </div>
</template>

<script>
import { Loyalty as LoyaltyService } from '@/services/SOLO';
import translations from '@/mixins/translations';
import V2BaseButton from '@/components/V2/V2BaseButton.vue';
import BaseField from '@/components/V2/BaseField.vue';

export default {
  name: 'LoyaltyCollection',
  mixins: [translations],
  components: {
    V2BaseButton,
    BaseField,
  },
  data() {
    return {
      loading: false,
      form: {
        mobile: '',
        points: ''
      },
      schemaValid: {
        mobile: false,
        points: false
      }
    };
  },
  computed: {
    isFormValid() {
      return !!this.form.mobile && !!this.form.points && !isNaN(this.form.points);
    }
  },
  methods: {
    validateForm() {
      this.schemaValid.mobile = !!this.form.mobile;
      this.schemaValid.points = !!this.form.points && !isNaN(this.form.points);
      return this.schemaValid.mobile && this.schemaValid.points;
    },
    resetForm() {
      this.form.mobile = '';
      this.form.points = '';
      this.schemaValid.mobile = false;
      this.schemaValid.points = false;
    },
    notifySuccess() {
      this.$notify({
        title: 'LOYALTY POINTS COLLECTION',
        verticalAlign: 'bottom',
        horizontalAlign: 'left',
        message: 'Points was added successfully!',
        type: 'success'
      });
    },
    notifyError(err) {
      const detail = err?.response?.data?.error?.[0]?.detail || 'Unknown error';
      this.$notify({
        title: 'POINTS COLLECTION ERROR',
        verticalAlign: 'bottom',
        horizontalAlign: 'left',
        message: detail,
        type: 'danger',
      });
    },
    async addPoints() {
      // Validate before submit
      if (!this.validateForm()) {
        return;
      }
      try {
        this.loading = true;
        await LoyaltyService.collectPointsByMobile(this.form.mobile, Number(this.form.points));
        this.notifySuccess();
        this.resetForm();
      } catch (err) {
        console.log(err);
        this.notifyError(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
